import React from 'react';
import { Link } from 'react-router-dom';
import FadeInImage from '../components/FadeInImage';
import ContentLayout from '../layout/ContentLayout';
import './PianoPage.css';

function PianoPage() {
	return (
		<ContentLayout contentHeader={'Piano teaching'}>
			<FadeInImage
				src='/therapy_small.jpg'
				alt='Piano teaching with Afra Jurkiewicz'
				className='pianoImage'
			/>
			<p className='content-paragraph'>
				I now accept new piano and music students from the area of South
				Herefordshire and Monmouthshire. Please get in touch to discuss the
				teaching plan for yourself or your child.
			</p>

			<h2 className='pianoPricingHeading'>Prices for 2024/25</h2>

		
			<ul className='pianoList'>
				<li>£35 - 1 hour tuition</li>
				<li>£30 - 45 mins tuition</li>
				<li>£25 - 30 mins tuition</li>
			</ul>
			
			<p className='content-paragraph'>
				<Link to='/contact'>Enquire about piano lessons and current prices</Link> for yourself or your child.
			</p>
		</ContentLayout>
	);
}

export default PianoPage;
